import { CampoAlterado, ArquivoConclusao } from "./types";
import { getStatusLabelDemanda } from "../../../../../../../utility/statusDemanda";

const formatarValor = (valor: any): string => {
    if (valor === null || valor === undefined || valor === '') return '—';
    if (typeof valor === 'boolean') return valor ? 'Sim' : 'Não';
    if (typeof valor === 'object') return JSON.stringify(valor, null, 2);
    return String(valor);
};

const formatarData = (valor: any): string => {
    if (!valor) return '—';
    try {
        const date = new Date(valor);
        if (isNaN(date.getTime())) return formatarValor(valor);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const seconds = String(date.getSeconds()).padStart(2, '0');
        return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
    } catch {
        return formatarValor(valor);
    }
};

const formatarSimNao = (valor: any): string => {
    if (valor === null || valor === undefined || valor === '') return '—';
    if (typeof valor === 'boolean') return valor ? 'Sim' : 'Não';
    const valorStr = String(valor).toLowerCase();
    if (valorStr === 'sim' || valorStr === 'yes' || valorStr === 'true' || valorStr === '1') return 'Sim';
    if (valorStr === 'nao' || valorStr === 'no' || valorStr === 'false' || valorStr === '0') return 'Não';
    return formatarValor(valor);
};

const obterRotuloCampo = (chave: string): string => {
    const mapaRotulos: Record<string, string> = {
        'status': 'Status',
        'data_conclusao': 'Data de Conclusão',
        'atrasada': 'Atrasada',
        'pendente_de_orientacao': 'Pendente de Orientação',
        'status_pendencias': 'Status de Pendências'
    };
    return mapaRotulos[chave] || chave.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
};

export const mapearCamposAlterados = (logProposta: any): CampoAlterado[] => {
    if (!logProposta) return [];

    let dadosAntes = logProposta.dados_antes;
    let dadosDepois = logProposta.dados_depois;

    if (typeof dadosAntes === 'string') {
        try {
            dadosAntes = JSON.parse(dadosAntes);
        } catch (e) {
            dadosAntes = null;
        }
    }

    if (typeof dadosDepois === 'string') {
        try {
            dadosDepois = JSON.parse(dadosDepois);
        } catch (e) {
            return [];
        }
    }

    if (!dadosDepois) return [];

    const campos: CampoAlterado[] = [];
    const camposRelevantes = ['status', 'data_conclusao', 'atrasada', 'pendente_de_orientacao', 'status_pendencias'];

    camposRelevantes.forEach(campo => {
        const antes = dadosAntes ? dadosAntes[campo] : null;
        const depois = dadosDepois[campo];

        if (antes !== depois) {
            let antesFormatado: string;
            let depoisFormatado: string;

            if (campo === 'status') {
                antesFormatado = antes ? getStatusLabelDemanda(antes) : '—';
                depoisFormatado = getStatusLabelDemanda(depois);
            } else if (campo === 'data_conclusao') {
                antesFormatado = formatarData(antes);
                depoisFormatado = formatarData(depois);
            } else if (campo === 'atrasada' || campo === 'pendente_de_orientacao') {
                antesFormatado = formatarSimNao(antes);
                depoisFormatado = formatarSimNao(depois);
            } else {
                antesFormatado = formatarValor(antes);
                depoisFormatado = formatarValor(depois);
            }

            campos.push({
                campo,
                label: obterRotuloCampo(campo),
                antes: antesFormatado,
                depois: depoisFormatado
            });
        }
    });

    return campos;
};

export const mapearArquivosConclusao = (logsArquivos: any[]): ArquivoConclusao[] => {
    if (!Array.isArray(logsArquivos)) return [];

    return logsArquivos
        .filter((log: any) => log.entidade_nome === 'proposta_arquivo')
        .map((log: any) => {
            const dadosDepois = typeof log.dados_depois === 'string' 
                ? JSON.parse(log.dados_depois) 
                : log.dados_depois;
            
            const dadosExtra = log.dados_extra;

            return {
                id_proposta_arquivo: log.entidade_id || dadosDepois?.id_proposta_arquivo,
                caminho: dadosDepois?.caminho || '—',
                tamanho: dadosExtra?.tamanho || '—'
            };
        })
        .filter((arquivo: ArquivoConclusao) => arquivo.id_proposta_arquivo);
};

